import { createSlice } from '@reduxjs/toolkit';

import { fetchPost } from './PostThunks';
import _cloneDeep from 'lodash/cloneDeep';

export const initialState = {
    data: null,
    isAccessDenied: false,
    reviewsData: null,
    subCategoryTitle: null,
    subCategories: null,
    page: null,
    loading: true,
    error: false,
};

const PostSlice = createSlice({
    name: 'post',
    initialState,
    reducers: {
        clearPostData: state => {
            state.data = null;
            state.reviewsData = null;
            state.subCategoryTitle = null;
            state.subCategories = null;
            state.page = null;
            state.loading = true;
            state.error = false;
        },
        setSubCategoryTitle: (state, { payload }) => {
            state.subCategoryTitle = payload.subCategoryTitle;
            state.subCategories = payload.subCategories;
            state.page = payload.page;
        },
        setAssignTo: (state, { payload }) => {
            state.data.assignTo = [...payload];
        },
        changeStatusOfPublishedPostOnProjectPostPage: (state, { payload }) => {
            state.data.status = payload.status;
        },
        changePostAfterAnswerOnProjectPostPage: (state, { payload }) => {
            state.data = _cloneDeep(payload.rawPostData);
            state.reviewsData = [...state.reviewsData, payload.newReview];
        },
        updateReviewInStore: (state, { payload }) => {
            state.reviewsData = [
                ...state.reviewsData.map(review =>
                    review.publisherUid === payload.publisherUid ? payload : review
                ),
            ];
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchPost.pending, state => {
                state.error = false;
                state.loading = true;
            })
            .addCase(fetchPost.fulfilled, (state, { payload }) => {
                state.data = payload.data;
                state.isAccessDenied = payload.isAccessDenied;
                state.reviewsData = payload.reviewsData;
                state.page = payload.page;
                state.subCategories = payload.subCategories;
                state.subCategoryTitle = payload.subCategoryTitle;
                state.loading = false;
            })
            .addCase(fetchPost.rejected, (state, { payload }) => {
                state.error = true;
                state.loading = false;
                alert(payload);
            });
    },
});

export const PostReducer = PostSlice.reducer;
export const PostActions = {
    ...PostSlice.actions,
    fetchPost,
};
